<template>
  <div class="page-wrapper">
    <div class="   container-custom  heading-wrapper">
      <AboutHeadingComponent :image-heading-left="heading.imageHeadingLeft"
                             :image-heading-right="heading.imageHeadingRight"
                             :line1="heading.line1"
                             :line2="heading.line2"
                             :line3="heading.line3"
                             :line4="heading.line4"
      />
    </div>
    <div class="highlight-box-wrapper container-custom ">
      <div class="row g-3">
        <div v-for="(highlight, index) in highlights" :key="index" class="highlight-box col-md-4 col-12">
          <HighlightIconBox :icon="highlight.icon" :title="highlight.title" @click="openModal(highlight.id)"/>
        </div>
      </div>
    </div>

    <div class="highlight-box-wrapper container-custom ">
      <div class="row g-3">
        <div v-for="(paragraph, index) in paragraphs" :key="index" class="col-md-4">
          <div class="about-paragraph-title"> {{ paragraph.title }}</div>
          <div class="about-paragraph-description"> {{ paragraph.description }}</div>
        </div>
      </div>
    </div>
    <div class=" container-custom">
      <div class="equipment-wrapper">
        <div class="heading-title-container">
          <div class="title">{{ equipment.title }}</div>
          <div class="description">{{ equipment.description }}</div>
        </div>
        <AboutTitleThumbnails5Grid2LightBox :description="equipment.description" :images="equipment.images"
                                            :title="equipment.title"/>
      </div>
      <div class="full-care-wrapper row">
        <div class="col-md-7 d-flex  align-items-center">
          <div>
            <div class="full-care-title"> {{ $t('full-care-title') }}</div>
            <div class="full-care-paragraph"> {{ $t('full-care-paragraph') }}</div>
            <div class="full-care-button">
              <router-link :to="{name: 'FullCareView'} ">
                <MainButton :button-text="$t('full-care-button')" icon="arrow-right" size="medium" theme="solid-blue"/>
              </router-link>

            </div>
          </div>

        </div>
        <div class="col-md-5 d-flex mt-5 mt-md-0">
          <VetruvianMan/>
        </div>

      </div>

    </div>
    <div class="hospital-background-wrapper position-relative">
      <div :style="{ backgroundImage: `url(${hospitaBackground.cloudsImage})` }" class="about-clouds-image">

      </div>
      <div class="d-md-flex">
        <div :style="{ backgroundImage: `url(${hospitaBackground.hospitalImage})` }" class="about-hospital-image">
        </div>
        <div class="hospital-content-wrapper d-flex align-items-center">
          <div>
            <div class="hospital-title"> {{ hospitaBackground.title }}</div>
            <div class="hospital-subtitle"> {{ hospitaBackground.subtitle }}</div>
            <div class="hospital-description"> {{ hospitaBackground.description }}</div>
            <div class="col-md-4">
              <a href="https://www.unihospitalbg.bg/" target="_blank">
                <MainButton :button-text="$t('hospital-button')" :icon="'arrow-forward-blue'" :size="'medium'"
                            :theme="'solid-white'"/>
              </a>

            </div>

          </div>


        </div>
      </div>

    </div>
    <div class="hotel-component container-custom">
      <div class="">
        <AboutHotelComponent :button-placeholder="hotel.buttonPlaceholder" :description="hotel.description"
                             :image-url="hotel.imageUrl"
                             :subtitle="hotel.subtitle"
                             :title="hotel.title"/>
      </div>
      <div class="d-flex justify-content-center text-center">
        <div class="hotel-additional-description"> {{ hotel.additionalInfo }}</div>
      </div>
      <div class="">
        <StaticThumbnailsGrid5Desktop2Mobile :items="hotel.items"/>
      </div>
    </div>
  </div>
  <ModalMain ref="modalComponent" :title="modalTitle" size="large">
    <div v-if="modalContent" class="modal-content-body mt-5" v-html="modalContent"></div>
  </ModalMain>

</template>

<script>


import HighlightIconBox from "@/components/Components/HIghlightIconBox/HighlightIconBox.vue";
import AboutHeadingComponent from "@/components/Components/AboutHeadingComponent/AboutHeadingComponent.vue";
import AboutTitleThumbnails5Grid2LightBox
  from "@/components/Components/AboutTitleThumbnails5Grid2LightBox/AboutTitleThumbnails5Grid2LightBox.vue";
import AboutHotelComponent from "@/components/Components/AboutHotelComponent/AboutHotelComponent.vue";
import StaticThumbnailsGrid5Desktop2Mobile
  from "@/components/Components/StaticThumbnailsGrid5Desktop2Mobile/StaticThumbnailsGrid5Desktop2Mobile.vue";
import MainButton from "@/components/Common/Buttons/MainButton.vue";
import VetruvianMan from "@/components/Common/Icons/VetruvianMan.vue";
import ModalMain from "@/components/Components/ModalMain/ModalMain.vue";

export default {
  name: 'AboutUsView',
  components: {
    ModalMain,
    VetruvianMan,
    MainButton,
    StaticThumbnailsGrid5Desktop2Mobile,
    AboutHotelComponent,
    AboutTitleThumbnails5Grid2LightBox,
    AboutHeadingComponent,
    HighlightIconBox
  },
  data() {
    return {
      heading: {},
      highlights: [],
      equipment: {},
      hospitaBackground: {},
      hotel: {},
      paragraphs: [],
      modalsData: null,
      modalContent: null,
      modalTitle: "",
    };
  },
  async mounted() {
    this.heading = {
      line1: this.$t('about-heading-title-1'),
      line2: this.$t('about-heading-title-2'),
      line3: this.$t('about-heading-title-3'),
      line4: this.$t('about-heading-title-4'),
      imageHeadingLeft: '/static/images/about-heading-left-image.webp',
      imageHeadingRight: '/static/images/about-heading-right-image.webp',
    };
    this.modalsData = await this.$store.dispatch("aboutUsModals/getAboutUsModals");

    this.highlights = [
      {
        id: 1,
        title: this.$t('about-highlight-1'),
        icon: 'heart'
      },
      {
        id: 2,
        title: this.$t('about-highlight-2'),
        icon: 'doctor'
      },
      {
        id: 3,
        title: this.$t('about-highlight-3'),
        icon: 'bed'
      },
    ];
    this.equipment = {
      title: this.$t('about-equipment-title'),
      description: this.$t('about-equipment-description'),
      images: [
        '/static/images/about-equiment-image-1.webp',
        '/static/images/about-equiment-image-2.webp',
        '/static/images/about-equiment-image-3.webp',
        '/static/images/about-equiment-image-4.webp',
        '/static/images/about-equiment-image-5.webp',

      ]
    };
    this.hospitaBackground = {
      cloudsImage: '/static/images/clouds-background.webp',
      hospitalImage: '/static/images/hospital-trim.webp',
      title: this.$t('about-hospital-background-title'),
      subtitle: this.$t('about-hospital-background-subtitle'),
      description: this.$t('about-hospital-background-description')
    };
    this.hotel = {
      title: this.$t('about-hotel-title'),
      subtitle: this.$t('about-hotel-subtitle'),
      buttonPlaceholder: this.$t('about-hotel-button'),
      description: this.$t('about-hotel-description'),
      imageUrl: '/static/images/about-hotel-image.webp',
      additionalInfo: this.$t('about-hotel-additional-information'),
      items: [
        {
          imageUrl: '/static/images/spa-image.webp',
          title: this.$t('about-hotel-highlight-1'),
          url: 'https://earthandpeople.bg/uslugi/spa'
        },
        {
          imageUrl: '/static/images/gym-image.webp',
          title: this.$t('about-hotel-highlight-2'),
          url: 'https://earthandpeople.bg/uslugi/spa'
        },
        {
          imageUrl: '/static/images/restaurant-image.webp',
          title: this.$t('about-hotel-highlight-3'),
          url: 'https://earthandpeople.bg/uslugi/restorant'
        },
        {
          imageUrl: '/static/images/bar-image.webp',
          title: this.$t('about-hotel-highlight-4'),
          url: 'https://earthandpeople.bg/uslugi/restorant'
        },
        {
          imageUrl: '/static/images/special-offers-image.webp',
          title: this.$t('about-hotel-highlight-5'),
          url: 'https://earthandpeople.bg/specialni-oferti'
        },
      ]
    };
    this.paragraphs = [
      {
        title: this.$t('about-paragraph-title-1'),
        description: this.$t('about-paragraph-description-1')
      },
      {
        title: this.$t('about-paragraph-title-2'),
        description: this.$t('about-paragraph-description-2')
      },
      {
        title: this.$t('about-paragraph-title-3'),
        description: this.$t('about-paragraph-description-3')
      },
    ]
  },
  methods: {
    openModal(id) {
      let vm = this;
      this.modalsData.forEach((item) => {
        console.log(id);
        console.log(item.id);
        if (item.id === id) {
          vm.modalContent = item.content
          vm.modalTitle = item.title
          vm.$nextTick(() => {
            vm.$refs.modalComponent?.showModal();
          });
        }
      })
    },
  },
};

</script>

<style lang="scss" scoped>
@import "~@/assets/scss/fonts.scss";

.page-wrapper {
  font-family: $font-regular;
  margin-top: 90px;
}

.about-paragraph-title {
  font-size: $title-h3;
  color: $color-brown;
  text-align: center;
}

.about-paragraph-description {
  font-size: $paragraph-1;
  text-align: center;
  padding: 0 40px;
}

.highlight-box {
  cursor: pointer;
}

.equipment-wrapper {
  position: relative;
  z-index: 52;
  border-radius: 30px;
  padding: 40px 10px;
  background: $color-light-brown;
  overflow: hidden;
  color: $color-brown;

  .title {
    font-size: $title-h5;
    line-height: 1;
    text-transform: uppercase;
    margin-bottom: $spacing-1;
  }

  .description {
    margin-bottom: $spacing-3;
  }
}

.full-care-wrapper {
  background: #F1F5F6;
  padding: 40px 10px;
  z-index: 512;
  border-radius: 30px;
  overflow: hidden;
  color: $color-blue-accent;
  margin-bottom: 200px;

  .full-care-title {
    font-size: $title-h5;
    line-height: 1;
    margin-bottom: $spacing-4;
  }

  .full-care-paragraph {
    margin-bottom: $spacing-3;
  }
}

.hospital-background-wrapper {
  height: 800px;
  width: 100%;

  .hospital-content-wrapper {
    background: $color-blue-accent;
    color: $color-white;
    position: relative;
    z-index: 30;
    transform: translate(0%, -10%);
    width: 100%;
    height: 600px;
    border-radius: 30px;
    padding: 50px;

    .hospital-title {
      font-size: $title-h5;
      line-height: 1;
      margin-bottom: $spacing-4;
    }

    .hospital-subtitle {
      font-size: $subtitle-1;
      line-height: $subtitle-1;
      margin-bottom: $spacing-4;
    }

    .hospital-description {
      margin-bottom: $spacing-3;
    }

    .button-placeholder {
      font-size: 25px;
      line-height: 25px;
      width: 10%;
      margin-left: 20px;
    }
  }

  .about-clouds-image {
    height: 1000px;
    width: 100%;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    position: absolute;
    bottom: 0;
    left: 0;
  }

  .about-hospital-image {
    height: 300px;
    width: 100%;
    transform: translate(0%, 0%);
    background-size: cover;
    background-repeat: no-repeat;
    background-position: left;
    z-index: 12;
    position: relative;
    bottom: 0;
    left: 0;
  }
}

.hotel-component {
  position: relative;
  z-index: 25;
  border-radius: 50px;
  background: $color-white;
  padding-top: 250px;
  padding-bottom: 50px;
  transform: translateY(-4%);

  .hotel-additional-description {
    margin: 60px 0;
  }

}

.highlight-box-wrapper, .heading-wrapper, .equipment-wrapper {
  margin-bottom: $spacing-10;
}

@media screen and (min-width: 768px) {
  .page-wrapper {
    margin-top: 140px;
  }
  .hospital-background-wrapper {
    padding-right: 60px;
    height: 600px;

    .hospital-content-wrapper {
      padding: 100px;
      width: 80%;
      transform: translate(0%, 10%);

      .hospital-title {
        text-transform: uppercase;
        font-size: $title-h2;
        line-height: $title-h2;
        font-family: $font-bold;
        margin-bottom: $spacing-2;
      }

      .hospital-subtitle {
        font-size: $subtitle-1;
        margin-bottom: $spacing-2;
      }

      .hospital-description {
        font-size: $paragraph-1;
        margin-bottom: $spacing-2;
        width: 80%;
      }


    }

    .about-clouds-image {
      height: 800px;
    }

    .about-hospital-image {
      background-size: cover;
      height: 600px;
    }
  }
  .equipment-wrapper, .full-care-wrapper {
    padding: 50px;
  }
  .full-care-wrapper {


    .full-care-title {
      text-transform: uppercase;
      font-size: $title-h2;
      line-height: $title-h2;
      font-family: $font-bold;
      margin-bottom: $spacing-7;
    }

    .full-care-button {
      max-width: 300px;
    }

    .full-care-paragraph {
      margin-bottom: $spacing-7;
    }
  }
  .hotel-component {
    .hotel-additional-description {
      max-width: 50%;
      margin: 100px 0;
    }
  }

}
</style>